<style lang="less">
    @import "../../../../../styles/common-table-list.less";
</style>
<template>
    <div class="center-table-list">
        <div class="table-list" >
            <div class="table-list-title">
                <span class="myTitle">个人实名</span>
            </div>

            <div class="personal_authentication_main">
                <ul class="main_group">
                    <li class="main_item">
                        <span class="item_title">证件类型：</span>
                        <div class="item_content"><span class="selection_box">身份证证件照认证</span></div>
                    </li>
                    <li class="main_item">
                        <span class="item_title top_title">上传证件：</span>
                        <div class="item_content">
                            <div class="upload_group">
                                <Upload
                                        type="drag"
                                        name="poUpload"
                                        :data="frontalRequestData"
                                        :action="this.API_ROOT_UPLOAD + 'bqjvip/ident/addNewPoPic'"
                                        :show-upload-list="false"
                                        :before-upload="frontalUpLoadBefore"
                                        :on-success="frontalUpLoadSuccess"
                                        :on-error="frontalUpLoadError"
                                        :on-exceeded-size="frontalExceededSize"
                                        :max-size="5120"
                                        accept=".jpg,.jpeg,.png"
                                        style="display: inline-block;vertical-align: top;">

                                    <!--  没有图片时  -->
                                    <div v-if="frontalState == -1" class="upload_text">
                                        <!-- <div class="upload_text_add">+</div>
                                        <p>上传正面1</p> -->
                                        <img src='./images/Z.png'/>
                                    </div>

                                    <!--  图片上传时  -->
                                    <div v-else-if="frontalState == 1" class="upload_ing">
                                        <div class="upload_ing_text">识别中...</div>
                                    </div>

                                    <!--  图片上传成功  -->
                                    <div v-else-if="frontalState == 0" class="upload_success">
                                        <img class="upload_success_img"
                                             :src="frontalPhoto"
                                             alt='版权登记'>
                                        <div class="upload_success_btn">重新上传</div>
                                    </div>
                                </Upload>
                                <Upload
                                        type="drag"
                                        name="poUpload"
                                        :data="reverseRequestData"
                                        :action="this.API_ROOT_UPLOAD + 'bqjvip/ident/addNewPoPic'"
                                        :show-upload-list="false"
                                        :before-upload="reverseUpLoadBefore"
                                        :on-success="reverseUpLoadSuccess"
                                        :on-error="reverseUpLoadError"
                                        :on-exceeded-size="reverseExceededSize"
                                        :max-size="5120"
                                        accept=".jpg,.jpeg,.png"
                                        style="display: inline-block;vertical-align: top;">
                                    <!--  没有图片时  -->
                                    <div v-if="reverseState == -1" class="upload_text">
                                        <img src='./images/F.png'/>
                                        <!-- <div class="upload_text_add">+</div>
                                        <p>上传反面</p> -->
                                    </div>

                                    <!--  图片上传时  -->
                                    <div v-else-if="reverseState == 1" class="upload_ing">
                                        <div class="upload_ing_text">识别中...</div>
                                    </div>

                                    <!--  图片上传成功  -->
                                    <div v-else-if="reverseState == 0" class="upload_success">
                                        <img class="upload_success_img"
                                             :src="reversePhoto"
                                             alt='版权登记'>
                                        <div class="upload_success_btn">重新上传</div>
                                    </div>

                                </Upload>
<!--                                <Upload
                                    type="drag"
                                    name="poUpload"
                                    :data="handRequestData"
                                    :action="this.API_ROOT_UPLOAD + 'bqjvip/ident/addNewPoPic'"
                                    :show-upload-list="false"
                                    :before-upload="holdByHandUpLoadBefore"
                                    :on-success="holdByHandUpLoadSuccess"
                                    :on-error="holdByHandUpLoadError"
                                    :on-exceeded-size="holdByHandExceededSize"
                                    :max-size="10240"
                                    accept=".jpg,.jpeg,.png"
                                    style="display: inline-block; vertical-align: top"
                                    >
                                    &lt;!&ndash;  没有图片时  &ndash;&gt;
                                    <div v-if="holdByHandState == -1" class="upload_text">
                                        <img src="../authentication/images/shouci.png" />
                                    </div>

                                    &lt;!&ndash;  图片上传时  &ndash;&gt;
                                    <div v-else-if="holdByHandState == 1" class="upload_ing">
                                        <div class="upload_ing_text">上传中...</div>
                                    </div>

                                    &lt;!&ndash;  图片上传成功  &ndash;&gt;
                                    <div v-else-if="holdByHandState == 0" class="upload_success">
                                        <img
                                        class="upload_success_img"
                                        :src="idHoldByHandUrl"
                                        alt="版权登记"
                                        />
                                        <div class="upload_success_btn">重新上传</div>
                                    </div>
                                </Upload>-->
                                <div class="upload_desc">
                                    <div>上传证件要求：</div>
                                    <ul class="upload_desc_group">
                                        <li>1、上传的证件内容必须清晰可见</li>
                                        <li>2、作者名称和证件号码与提交的证件信息一致</li>
                                        <li>3、要求不得涂改，需确保四边角完整，水印、文字、图片、证件号码等清晰可辨</li>
                                        <li>4、须小于5MB，且为JPG格式，尺寸过小不宜上传(推荐800*600以上）</li>
                                        <li>5、证件在有效期之内</li>
                                    </ul>
                                    <div class="demo_img">
                                        <img src="./images/upload_demo.png" alt='版权登记'>
                                        <ol class="demo_text">
                                            <li>标准</li>
                                            <li style="padding-left: 12px;">边框缺失</li>
                                            <li>照片模糊</li>
                                            <li>闪光强烈</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="main_item">
                        <span class="item_title">姓名：</span>
                        <div class="item_content">
                            <i-input v-model="modifyUserName" placeholder="请输入姓名"></i-input>
                        </div>
                    </li>
                    <li class="main_item">
                        <span class="item_title">证件号：</span>
                        <div class="item_content">
                            <i-input v-model="modifyIdCardNum" placeholder="请输入证件号"></i-input>
                        </div>
                    </li>
                    <li class="main_item">
                        <span class="item_title">国家省市：</span>
                        <div class="item_content" style="color: #CBCBCB;">
                            <Select class="item_city_list" v-model="countrySelection">
                                <Option :value="countrySelection">{{countrySelection}}</Option>
                            </Select>
                            —
                            <Select class="item_city_list" v-model="provincesSelection" @on-change="provinceChange">
                                <Option v-for="(item,index) in cityData" :value="index" :key="index">{{index}}</Option>
                            </Select>
                            —
                            <Select class="item_city_list" v-model="citySelection">
                                <Option v-for="(item,index) in cityData[provincesSelection]" :value="item" :key="index">{{item}}</Option>
                            </Select>

                        </div>
                    </li>
                    <li class="main_item">
                        <span class="item_title">详细地址：</span>
                        <div class="item_content">
                            <i-input v-model="detailedAddress" maxlength="100" placeholder="请输入详细地址"></i-input>
                        </div>
                    </li>
                    <li class="main_item">
                        <span class="item_title">证件有效期：</span>
                        <div class="item_content">
                            <DatePicker class="item_date_list" style="width: 165px;" type="date" placeholder="开始时间"
                                        :value="startTime"
                                        format="yyyy-MM-dd"
                                        @on-change="startTimeChange"
                                        :options="disabledDate[0].start"></DatePicker>
                            <Select v-model="dateTypeValue" @on-change="dateTypeChange" class="item_date_list"
                                    style="width: 175px;height: 48px;">
                                <Option v-for="(item,index) in dateType" :value="item.value" :key="index">{{item.label}}</Option>
                            </Select>
                            <DatePicker v-show="dateTypeValue!=0" class="item_date_list" style="width: 165px;"
                                        type="date"
                                        :value="dateTypeValue == 0? endTime='长期' : endTime "
                                        placeholder="结束时间"
                                        format="yyyy-MM-dd"
                                        @on-change="endTimeChange"
                                        :options="disabledDate[1].end"></DatePicker>
                        </div>
                    </li>

<!--                  <div class="table-list-title">
                    <span class="myTitle">重要联系信息</span>
                  </div>
                  <li class="main_item">
                    <span class="item_title">联系地址：</span>
                    <div class="item_content">
                      <i-input v-model="address" maxlength="100" placeholder=""></i-input>
                    </div>
                  </li>
                  <li class="main_item">
                    <span class="item_title">邮编：</span>
                    <div class="item_content">
                      <i-input v-model="postCode" maxlength="100" placeholder=""></i-input>
                    </div>
                  </li>
                  <li class="main_item">
                    <span class="item_title">联系人：</span>
                    <div class="item_content">
                      <i-input v-model="linkMan" maxlength="100" placeholder=""></i-input>
                    </div>
                  </li>

                  <li class="main_item">
                    <span class="item_title">联系电话：</span>
                    <div class="item_content">
                      <i-input v-model="linkPhone" maxlength="100" placeholder=""></i-input>
                    </div>
                  </li>

                  <li class="main_item">
                    <span class="item_title">Email：</span>
                    <div class="item_content">
                      <i-input v-model="email" maxlength="100" placeholder=""></i-input>
                    </div>
                  </li>

                  <li class="main_item">
                    <span class="item_title">传真：</span>
                    <div class="item_content">
                      <i-input v-model="faxNum" maxlength="100" placeholder=""></i-input>
                    </div>
                  </li>

                  <li class="main_item">
                    <span class="item_title">选择用户所属行业：</span>
                    <div class="item_content">
                      <Select v-model="industryId"  @on-change="changeLevel1" class="item_date_list" style="width: 400px;">
                        <Option v-for="item in level1List" :value="item.id" :key="item.id">{{ item.value }}</Option>
                      </Select>
                    </div>
                  </li>
                  <li class="main_item">
                    <span class="item_title">选择用户所属二级行业：</span>
                    <div class="item_content">
                      <Select v-model="secindustryId" class="item_date_list" style="width: 400px;">
                        &lt;!&ndash;level2list数组里面只有Location_L&ndash;&gt;
                        <Option v-for="item in level2list" :value="item.id" :key="item.id" >{{ item.Location_L}}</Option>
                      </Select>
                    </div>
                  </li>



                  <li class="main_item">
                    <span class="item_title">选择登办理点：</span>
                    <div class="item_content">
                      <Select class="item_date_list" v-model="belongRegionId" style="width: 400px;">
                        <Option v-for="(item,index) in belongRegionsData" :value="item.id" :key="item.id">{{item.belongRegionName}}</Option>
                      </Select>
                    </div>
                  </li>-->
                </ul>
            </div>
            <div class="tipMsg" style="padding: 28px 25px;font-size: 14px;">温馨提示：为保障权利人权益，请确认以上是真实身份信息并进行实名身份信息认证，提交后不可修改。</div>
            <div style="padding: 30px 0;text-align: center">
                <div class="submit_btn" @click="checkSubmit">认证</div>
            </div>

        </div>
    </div>

</template>

<script>
import {_getProvinceAndCityList, _getpersonRealName, _findMainObligee} from "@/api/authentication.js";
    import {userInfo} from "@/api/index";
    import Cookies from "js-cookie";
import util from "@/libs/util";


    export default {
        metaInfo: {
            title: '个人认证|前海版权综合服务平台',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权服务,版权百科,版权,前海版权综合服务平台,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
            }, {
                name: 'Description',
                content: '个人认证,前海版权综合服务平台,人人都是创作者，人人都是版权人。前海版权综合服务平台秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
            }]
        },
        name: "personalAuthentication",
        data() {
            return {
                accessToken: {},
                saveLogin: false, //重置用户是否自动保存
                getId: '', //获取页面上传递的id
                userName: '', //姓名
                modifyUserName: '', //修改后的姓名
                idCardNum: '', //身份证号
                modifyIdCardNum: '', //修改后的身份证号
                frontalRequestData: {picType: 'idCadeOn'}, //上传身份证正面请求参数
                reverseRequestData: {picType: 'idCadeBack'}, //上传身份证反面请求参数
                handRequestData: {picType: 'handImgUrl'},//上传手持身份证参数
                frontalFileId: '', //身份证正面照片id
                reverseFileId: '', //身份证反面照片id
                holdByHandFileId: "", //手持身份证照片id
                frontalPhoto: '', //身份证正面照片
                reversePhoto: '', //身份证反面照片
                // idHoldByHandUrl: '', //手持身份证
                frontalState: -1, //正面身份证上传状态：-1:未上传，1:上传中，0:上传成功
                reverseState: -1, //反面身份证上传状态：-1:未上传，1:上传中，0:上传成功
                holdByHandState: -1, //手持身份证上传状态：-1:未上传，1:上传中，0:上传成功
                cityData: [], //省份城市列表
                countrySelection: '中国', //选中国家
                provincesSelection: '', //选中省份
                citySelection: '', //选中城市
                detailedAddress: '', //详细地址

                address: '',//联系地址
                postCode: '',//邮编
                linkMan: '',//联系人
                linkPhone: '',//联系电话
                email: '',//邮箱
                faxNum: '',//传真
                belongRegionId: '',//办理点
                industryId: '',//一级行业
                secindustryId: '',//二级行业
                belongRegionsData: [],//办理点列表

                level2list:[],
                level1List: [
                  {
                    id: '1',
                    value: '农、林、牧、渔业',
                    label:[
                      {
                        "id":'0',
                        "Location_L":"无",
                        "isShow":true
                      }
                    ]
                  },
                  {
                    id: '2',
                    value: '采矿业',
                    label:[
                      {
                        "id":'0',
                        "Location_L":"无",
                        "isShow":true
                      }
                    ]
                  },
                  {
                    id: '3',
                    value: '制造业',
                    label:[
                      {
                        "id":'21',
                        "Location_L":"食品制造业",
                        "isShow":true
                      },
                      {
                        "id":'22',
                        "Location_L":"酒、饮料和精制茶制造业",
                        "isShow":true
                      },
                      {
                        "id":'23',
                        "Location_L":"纺织服装、服饰业",
                        "isShow":true
                      },
                      {
                        "id":'24',
                        "Location_L":"皮革、毛皮、羽毛及其制品和制鞋业",
                        "isShow":true
                      },
                      {
                        "id":'25',
                        "Location_L":"木材加工和木、竹、藤、棕、草制品业",
                        "isShow":true
                      },
                      {
                        "id":'26',
                        "Location_L":"家具制造业",
                        "isShow":true
                      },
                      {
                        "id":'27',
                        "Location_L":"造纸和纸制品业",
                        "isShow":true
                      },
                      {
                        "id":'28',
                        "Location_L":"印刷和记录媒介复制业",
                        "isShow":true
                      },
                      {
                        "id":'29',
                        "Location_L":"文教、工美、体育和娱乐用品制造业",
                        "isShow":true
                      },
                      {
                        "id":'30',
                        "Location_L":"汽车制造业",
                        "isShow":true
                      },
                      {
                        "id":'31',
                        "Location_L":"计算机、通信和其他电子设备制造业",
                        "isShow":true
                      },
                      {
                        "id":'32',
                        "Location_L":"其他制造业",
                        "isShow":true
                      }
                    ]
                  },
                  {
                    id: '4',
                    value: '电力、热力、燃气及水生产和供应业',
                    label:[
                      {
                        "id":'0',
                        "Location_L":"无",
                        "isShow":true
                      }
                    ]
                  },
                  {
                    id: '5',
                    value: '建筑业',
                    label:[
                      {
                        "id":'0',
                        "Location_L":"无",
                        "isShow":true
                      }
                    ]
                  },
                  {
                    id: '6',
                    value: '批发和零售业',
                    label:[
                      {
                        "id":'0',
                        "Location_L":"无",
                        "isShow":true
                      }
                    ]
                  },
                  {
                    id: '7',
                    value: '交通运输、仓储和邮政业',
                    label:[
                      {
                        "id":'0',
                        "Location_L":"无",
                        "isShow":true
                      }
                    ]
                  },
                  {
                    id: '8',
                    value: '住宿和餐营业',
                    label:[
                      {
                        "id":'33',
                        "Location_L":"住宿业",
                        "isShow":true
                      },
                      {
                        "id":'34',
                        "Location_L":"餐饮业",
                        "isShow":true
                      }
                    ]
                  },
                  {
                    id: '9',
                    value: '信息传输、软件和信息技术服务业',
                    label:[
                      {
                        "id":'0',
                        "Location_L":"无",
                        "isShow":true
                      }
                    ]
                  },
                  {
                    id: '10',
                    value: '金融业',
                    label:[
                      {
                        "id":'0',
                        "Location_L":"无",
                        "isShow":true
                      }
                    ]
                  },
                  {
                    id: '11',
                    value: '房地产业',
                    label:[
                      {
                        "id":'0',
                        "Location_L":"无",
                        "isShow":true
                      }
                    ]
                  },
                  {
                    id: '12',
                    value: '租赁和商务服务业',
                    label:[
                      {
                        "id":'0',
                        "Location_L":"无",
                        "isShow":true
                      }
                    ]
                  },
                  {
                    id: '13',
                    value: '科学研究和技术服务业',
                    label:[
                      {
                        "id":'0',
                        "Location_L":"无",
                        "isShow":true
                      }
                    ]
                  },
                  {
                    id: '14',
                    value: '水利、环境和公共设施管理业',
                    label:[
                      {
                        "id":'0',
                        "Location_L":"无",
                        "isShow":true
                      }
                    ]
                  },
                  {
                    id: '15',
                    value: '居民服务、修理和其他服务业',
                    label:[
                      {
                        "id":'0',
                        "Location_L":"无",
                        "isShow":true
                      }
                    ]
                  },
                  {
                    id: '16',
                    value: '教育',
                    label:[
                      {
                        "id":'0',
                        "Location_L":"无",
                        "isShow":true
                      }
                    ]
                  },
                  {
                    id: '17',
                    value: '卫生和社会服务工作',
                    label:[
                      {
                        "id":'0',
                        "Location_L":"无",
                        "isShow":true
                      }
                    ]
                  },
                  {
                    id: '18',
                    value: '文化、体育和娱乐业',
                    label:[
                      {
                        "id":'35',
                        "Location_L":"新闻和出版业",
                        "isShow":true
                      },
                      {
                        "id":'36',
                        "Location_L":"广播、电视、电影和录音作业",
                        "isShow":true
                      },
                      {
                        "id":'37',
                        "Location_L":"文化艺术业",
                        "isShow":true
                      },
                      {
                        "id":'38',
                        "Location_L":"体育",
                        "isShow":true
                      },
                      {
                        "id":'39',
                        "Location_L":"娱乐业",
                        "isShow":true
                      }
                    ]
                  },
                  {
                    id: '19',
                    value: '公共管理、社会保障和社会组织',
                    label:[
                      {
                        "id":'0',
                        "Location_L":"无",
                        "isShow":true
                      }
                    ]
                  },
                  {
                    id: '20',
                    value: '国际组织',
                    label:[
                      {
                        "id":'0',
                        "Location_L":"无",
                        "isShow":true
                      }
                    ]
                  }

                ],
                disabledDate: [
                    {
                        start: {
                            disabledDate(date) {
                                return date && date.valueOf() > Date.now() - 172800;
                            }
                        }
                    },
                    {
                        end: {
                            disabledDate(date) {
                                return date && date.valueOf() < Date.now() - 8.64e7;
                            }
                        }
                    }
                ], //时间限制条件
                dateType: [
                    {value: 0, label: '无期限'},
                    {value: 1, label: '有期限（请选择日期）'},
                ], //时间下拉框选项
                dateTypeValue: 0, //当前时间选择值
                startTime: '', //证件开始时间
                endTime: '', //证件结束时间
                btnFlag: true, //防止重复点击


            }
        },
        beforeCreate() {
            // console.log(JSON.parse(Cookies.get("userInfo")))

        },
        created() {
            this.accessToken = {
                accessToken: Cookies.get("accessToken"),
            };
            this.getProvinceAndCityList();
            // this.getBelongRegions();
            if (this.$route.query.id && this.$route.query.id != '') {
                this.getId = this.$route.query.id;
                this.findMainObligee();
                // this.findGsfwUser();
            }
        },
        methods: {
            initialLevel2(){
              for(var i = 0;i<this.level1List.length;i++){
                if(this.level1List[i].id == this.industryId){
                  for(var k = 0;k < this.level1List[i].label.length;k++){
                    if(this.level1List[i].label[k].id == this.secindustryId){
                      this.level2list = this.level1List[i].label;
                    }
                  }
                }
              }
            },
            changeLevel1(){
              //循环level1List数组
              for(var i = 0;i<this.level1List.length;i++){
                //如果当前点击的数组value等于他自己当前v-model
                if(this.level1List[i].id == this.industryId){
                  //就把数组label绑定le2list
                  this.level2list = this.level1List[i].label;
                }
              }
            },

            /****************身份证正面**************/
            frontalUpLoadBefore() {
                this.frontalState = 1;
            },
            frontalUpLoadSuccess(res) {
                if (res.code == 200 && !res.message) {
                    let result = res.result;
                    this.userName = result.name;
                    this.modifyUserName = result.name;
                    this.frontalFileId = res.fileId;
                    this.frontalPhoto = res.fileUrl;
                    this.idCardNum = result.id;
                    this.modifyIdCardNum = result.id;
                    this.detailedAddress = result.address;
                    this.frontalState = 0;
                } else {
                    this.frontalUpLoadError();
                }
            },
            frontalExceededSize() {
                toast('证件大小不得超过5MB');
                this.frontalUpLoadError(true);
            },
            frontalUpLoadError(showToast) {
                this.frontalFileId = '';
                this.frontalState = -1;
                if (!showToast) {
                    toast('解析失败，请重试');
                }
            },

            /****************身份证反面**************/
            reverseUpLoadBefore() {
                this.reverseState = 1;
            },
            reverseUpLoadSuccess(res) {
                if (res.code == 200 && !res.message) {
                    let result = res.result;
                    this.reversePhoto = res.fileUrl;
                    this.reverseFileId = res.fileId;
                    this.startTime = result.validStart;
                    if (result.validEnd != '长期') {
                        this.endTime = result.validEnd;
                        this.dateTypeValue = 1;
                    } else {
                        this.dateTypeValue = 0;
                    }
                    this.reverseState = 0;
                } else {
                    this.reverseUpLoadError();
                }
            },
            reverseExceededSize() {
                toast('证件大小不得超过5MB');
                this.reverseUpLoadError(true);
            },
            reverseUpLoadError(showToast) {
                this.reverseFileId = '';
                this.reverseState = -1;
                if (!showToast) {
                    toast('解析失败，请重试');
                }
            },

            /****************手持身份证**************/
            /*holdByHandUpLoadBefore() {
                this.holdByHandState = 1;
            },
            holdByHandUpLoadSuccess(res) {
                if (res.code == 200) {
                    this.idHoldByHandUrl = res.fileUrl;
                    this.holdByHandFileId = res.fileId
                    this.holdByHandState = 0;
                } else {
                    this.holdByHandUpLoadError();
                }
            },
            holdByHandExceededSize() {
                this.$toast("证件大小不得超过10MB");
                this.holdByHandUpLoadError(true);
            },
            holdByHandUpLoadError(showToast) {
                this.idHoldByHandUrl = "";
                this.holdByHandState = -1;
                if (!showToast) {
                    this.$toast("解析失败，请重试");
                }
            },*/


            /****************获取省市列表接口数据**************/
            getProvinceAndCityList() {
                _getProvinceAndCityList().then(res => {
                    if (res) {
                        this.cityData = res;
                    }
                });

            },//获取办理点
            /*getBelongRegions() {
              _getBelongRegions().then(res => {
                if (res.code == '200') {
                  this.belongRegionsData = res.result;
                }else{
                  var br = "[{\"belongRegionName\":\"前海版权服务中心\",\"address\":\"甘肃省兰州市城关区雁南路279号科庆综合楼12楼知识产权港公司版权部\",\"id\":1},{\"belongRegionName\":\"兰州文创产业园知识产权服务站\",\"address\":\"\",\"id\":3},{\"belongRegionName\":\"江苏版权登记\",\"address\":\"甘肃省兰州市城关区雁南路279号\",\"id\":4},{\"belongRegionName\":\"甘肃省高校版权登记服务站（甘肃政法大学办理点）\",\"address\":\"甘肃省兰州市安宁西路6号 \",\"id\":6},{\"belongRegionName\":\"北京前海版权公共服务平台办理点\",\"address\":\"甘肃省兰州市城关区雁南路279号12层\",\"id\":8},{\"belongRegionName\":\"北京易同信和信息服务\",\"address\":\"甘肃省兰州市城关区雁南路279号\",\"id\":10}]";
                  this.belongRegionsData = JSON.parse(br);
                }
              });

            },*/
            provinceChange(value) {
                this.citySelection = this.cityData[value][0];
            },

            /****************证件有效期开始时间**************/
            startTimeChange(value) {
                this.startTime = value;
            },

            /****************证件有效期结束时间**************/
            endTimeChange(value) {
                this.endTime = value;
            },

            /****************证件是否长期有效的改变事件**************/
            dateTypeChange(value) {
                this.endTime = '';
            },


            /****************获取相对应的认证信息**************/
            findMainObligee() {
                _findMainObligee().then(res => {
                    console.log(res);
                    if (res.code == 200) {
                        let result = res.result;
                        let endTime = result.attachEndTime;

                        this.frontalFileId = result.attachment1;
                        this.frontalPhoto = result.attachment1Url;
                        this.frontalState = 0;
                        this.reverseFileId = result.attachment2;
                        this.reversePhoto = result.attachment2Url;
                        this.reverseState = 0;
                        this.userName = result.name;
                        this.modifyUserName = result.name;
                        this.idCardNum = result.identityNumber;
                        this.modifyIdCardNum = result.identityNumber;
                        this.detailedAddress = result.address;
                        this.startTime = result.attachStartTime;
                        this.holdByHandState = 0
                        // this.idHoldByHandUrl = result.handImgUrl
                        // this.holdByHandFileId = result.handImgUrl
                        if (endTime != '长期') {
                            this.dateTypeValue = 1;
                            this.endTime = endTime;
                        }
                    }
                })
            },
/*
            findGsfwUser(){
              _findGsfwUser().then(res => {
                console.log(res);
                if (res.code == 200) {
                  let result = res.result;

                  this.address = result.linkAddress;
                  this.postCode = result.postCode;
                  this.linkMan = result.linkMan;
                  this.linkPhone = result.linkPhone;
                  this.linkMan = result.linkMan;
                  this.email = result.email;
                  this.faxNum = result.faxNum;
                  this.belongRegionId = result.belongRegionId;
                  this.industryId = result.industryId;
                  this.secindustryId = result.secindustryId;
                  this.belongRegionsData = result.belongRegionsData;

                  this.initialLevel2();
                }
              })
            },*/

            /****************提交认证**************/
            checkSubmit() {
                if(!this.btnFlag){
                    return
                }
                let _userInfo = JSON.parse(Cookies.get("userInfo"));
                let data = {
                    identityType: 1,
                    authMethod: 'idcard',
                    name: this.userName,
                    modifyName: this.modifyUserName,
                    identityNo: this.idCardNum,
                    modifyIdentityNo: this.modifyIdCardNum,
                    country: this.countrySelection,
                    province: this.provincesSelection,
                    city: this.citySelection,
                    address: this.detailedAddress,
                    registerId: _userInfo.id,
                    attachment1: this.frontalFileId,
                    attachment1Uuid: this.frontalFileId,
                    attachment2: this.reverseFileId,
                    attachment2Uuid: this.reverseFileId,
                    attachStartTime: this.startTime,
                    attachEndTime: this.endTime,
                    handImgUrl: this.holdByHandFileId,

                    linkAddress: this.address,
                    postCode: this.postCode,
                    linkMan: this.linkMan,
                    linkPhone: this.linkPhone,
                    email: this.email,
                    faxNum: this.faxNum,
                    belongRegionId: this.belongRegionId,
                    industryId: this.industryId,
                    secindustryId: this.secindustryId
                };
                console.log(data);
                //去掉手持身份证判断 去掉手机联系人判断 去掉办理点判断  去掉用戶所屬行業和二級行業判斷  去掉郵箱判斷
                //&& this.linkPhone != '' && this.linkMan != '' && this.holdByHandFileId != '' && this.belongRegionId != ''  && this.industryId != '' && this.secindustryId != '' && this.email != ''

                if (this.modifyUserName != '' && this.modifyIdCardNum != '' && this.frontalFileId != ''  && this.reverseFileId != ''
                    && this.provincesSelection != '' && this.citySelection != '' && this.detailedAddress != '' && this.startTime != '' && this.endTime != '') {
                    this.btnFlag = false;
                    /*if (!util.checkPhoneNum(this.linkPhone)) {
                      toast('手机号格式错误');
                      this.btnFlag = true;
                      return;
                    }
                    var reg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
                    if (!reg.test(this.email)) {
                      toast('邮箱格式错误');
                      this.btnFlag = true;
                      return;
                    }

                    var postCodeReg = /^[0-8][0-7]\d{4}$/;
                    if (!postCodeReg.test(this.postCode)) {
                      toast('邮编格式错误');
                      this.btnFlag = true;
                      return;
                    }*/

                    //保存联系人信息
                    /*_saveGsfwUser(data).then(res => {
                      if (res.code != 200) {
                        toast('联系信息保存失败');
                        this.btnFlag = true;
                        return;
                      }
                    })*/
                    _getpersonRealName(data).then(res => {
                        console.log(res)
                        if (res.code == 200) {
                            // 获取用户信息
                            userInfo().then(res => {
                                if (res.code == 200) {
                                    toast('认证成功');

                                    // 避免超过大小限制
                                    if (this.saveLogin) {
                                        // 保存7天
                                        Cookies.set("userInfo", JSON.stringify(res.result), {
                                            expires: 7
                                        });
                                    } else {
                                        Cookies.set("userInfo", JSON.stringify(res.result));
                                    }
                                    this.setStore("userInfo", res.result);
                                    let photo = res.result.photo ? res.result.photo : '';
                                    this.$store.commit("setAvatarPath", photo);
                                    this.$router.push("/obligee");
                                } else {
                                    toast('认证失败，请重试');
                                }
                            }, err => {

                            });


                        } else {
                            toast(res.message);
                        }
                        this.btnFlag = true;
                    }, (err) => {
                        console.log(err);
                        this.btnFlag = true;

                    });
                } else {
                    toast('请填写完整后再提交');
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .center-table-list .table-list {
        height: 100%;
    }

    .main_group .main_item {
        display: flex;
        border-bottom: 1px solid #F3F3F3;
        padding: 20px 35px;
        color: #666;
        font-size: 14px;
    }

    .main_item .item_title {
        width: 130px;
        align-self: center;
    }

    .main_item .item_title.top_title {
        align-self: auto;
    }

    .main_item .item_content {
        flex: 1;
    }

    .item_content .selection_box:before {
        content: '';
        width: 12px;
        height: 12px;
        background: #2196F3;
        display: inline-block;
        margin-right: 5px;
        vertical-align: middle;
        margin-top: -3px;
    }

    .upload_group .upload_desc {
        padding-top: 15px;
        color: #999999;
        font-size: 12px;
        line-height: 17px;
    }

    .upload_desc .demo_img {
        width: 327px;
        padding-top: 14px;
    }

    .upload_desc .demo_text {
        width: 335px;
        color: #666666;
        font-size: 12px;
        font-weight: bold;
        padding-top: 4px;
        display: flex;
        justify-content: space-around;
        list-style: none;
    }

    .demo_img img {
        display: block;
        width: 100%;
        height: 48px;
    }

    .upload_desc .upload_desc_group {
        list-style: none;
        padding-top: 5px;
    }

    /deep/ .ivu-input {
        width: 400px;
        height: 48px;
        /*border: 1px solid #CBCBCB;*/
        border-radius: 2px;
        box-shadow: none;
        font-size: 14px;
        line-height: 48px;
        color: #333;
        padding: 0 10px;
    }

    /deep/ .ivu-input::-webkit-input-placeholder { /* Chrome/Opera/Safari */
        color: #999999;
    }

    .ivu-input::-moz-placeholder { /* Firefox 19+ */
        color: #999999;
    }

    .ivu-input:-ms-input-placeholder { /* IE 10+ */
        color: #999999;
    }

    .ivu-input:-moz-placeholder { /* Firefox 18- */
        color: #999999;
    }


    .myu_upload {
        justify-content: center;
        display: flex;
        flex-direction: column;
        align-items: center;

        p {
            height: 20px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 20px;
            margin-top: 10px;
        }
    }


    /deep/ .ivu-upload {
        width: 180px;
        height: 110px;
        margin-right: 20px;
        display: flex;
    }

    /deep/ .ivu-upload-drag {
        border: 1px solid #CBCBCB;
    }

    .upload_text {
        align-self: center;
        margin: 0 auto;
        color: #999;
        font-size: 12px;
        img{
            width: 162px;
            height: 81px;
            display: block;
            margin: auto;
        }
    }

    .upload_ing {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, .5);
        display: flex;
    }

    .upload_ing .upload_ing_text {
        color: #fff;
        align-self: center;
        margin: 0 auto;
    }

    .upload_success {
        position: relative;
        width: 100%;
    }

    .upload_success .upload_success_img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .upload_success:after {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, .5);
        z-index: 2;
    }

    .upload_success .upload_success_btn {
        width: 82px;
        height: 26px;
        line-height: 26px;
        background: #2196F3;
        text-align: center;
        cursor: pointer;
        border-radius: 2px;
        color: #fff;
        position: absolute;
        left: 50%;
        top: 50%;
        z-index: 3;
        font-size: 14px;
        margin: -13px 0 0 -41px;
        transition: .3s ease-out;
    }

    .upload_success .upload_success_btn:hover {
        color: #fff;
        background-color: #cf7700;
        border-color: #cf7700;
    }

    .upload_text .upload_text_add {
        color: #A9A9A9;
        font-size: 40px;
        line-height: 1;
        margin-bottom: 9px;
    }

    /deep/ .ivu-date-picker .ivu-input {
        width: 100%;
    }

    /deep/ .item_date_list .ivu-input-suffix i {
        line-height: 48px;
    }

    .item_content .item_date_list {
        margin-right: 30px;
    }

    .item_content .item_date_list:last-child {
        margin-right: 0;
    }

    .item_content .item_city_list {
        width: 140px;
        height: 32px;
        /*margin-right: 35px;*/
    }

    .item_content .item_city_list:last-child {
        margin-right: 0;
    }

    /deep/ .item_city_list.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
        text-align: center;
        color: #333333;
    }


    /deep/ .item_date_list.ivu-select-single .ivu-select-selection {
        height: 48px;
        border-radius: 2px;
    }

    /deep/ .item_date_list.ivu-select-single .ivu-select-selection .ivu-select-placeholder {
        height: 48px;
        line-height: 48px;
        color: #999999;
    }

    /deep/ .item_date_list.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
        height: 48px;
        line-height: 48px;
    }

    .submit_btn {
        width: 230px;
        height: 42px;
        line-height: 42px;
        background: #2196F3;
        color: #fff;
        font-size: 14px;
        font-weight: 600;
        text-align: center;
        display: inline-block;
        border-radius: 4px;
        cursor: pointer;
    }


</style>
